import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-window-container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "content" }


export default /*#__PURE__*/_defineComponent({
  ...{
  name: 'ModalWindow',
},
  __name: 'ModalWindow',
  props: {
    smallModal: { type: Boolean, default: false },
    mediumModal: { type: Boolean, default: false },
    autoWidth: { type: Boolean, default: false },
    closeBtn: { type: Boolean, default: true }
  },
  emits: ['close'],
  setup(__props: any) {







return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "modal-fade",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "modal-container",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close', false)))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(['modal', { 'small-modal': _ctx.smallModal }, { 'medium-modal': _ctx.mediumModal }, { 'auto-width': _ctx.autoWidth }]),
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "title")
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ]),
          (_ctx.closeBtn)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close', false)))
              }))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _: 3
  }))
}
}

})